import { PropTypes } from 'prop-types';
import { Box } from '@mui/material';
import failedIcon from '../images/failed_icon.png';
import deliveredIcon from '../images/delivered_icon.png';
import sentReceivedIcon from '../images/sent_received_icon.png';
import { CommonStyles as CommoncssStyles } from '../../styles/ChatBotCommonStyles';

const MessageStatus = (props) => {
  const { message, lexError } = props;

  if (message.isOwn) {
    if (message.msgForAgent) {
      let srcImg = '';
      if (message.sentFailedStatus) {
        srcImg = failedIcon;
      } else if (message.readStatus) {
        srcImg = sentReceivedIcon;
      } else {
        srcImg = deliveredIcon;
      }
      return <Box component="img" sx={CommoncssStyles.msg_status} src={srcImg} alt="status icon" />;
    }
    return (
      <Box
        component="img"
        sx={CommoncssStyles.msg_status}
        src={sentReceivedIcon}
        alt={lexError ? 'failed' : 'sent'}
      />
    );
  }
  return null;
};
MessageStatus.propTypes = {
  message: PropTypes.object,
  lexError: PropTypes.bool,
};
export default MessageStatus;
